document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(() => {
  const routes = (window.theme && window.theme.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  const formatMoney = (cents) => {
    const value = Number(cents) / 100;
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = moneyFormat.match(placeholder);
    const key = match ? match[1] : 'amount';
    let amount;
    switch (key) {
      case 'amount_no_decimals':
        amount = Math.round(value).toLocaleString('en-US');
        break;
      case 'amount_with_comma_separator':
        amount = value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = Math.round(value).toLocaleString('de-DE');
        break;
      default:
        amount = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return moneyFormat.replace(placeholder, amount);
  };

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.classList.toggle('is-open', !isOpen);
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  let lastFocused = null;

  const openDrawer = () => {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    const closeButton = drawer.querySelector('.cart-drawer__close');
    if (closeButton) closeButton.focus();
  };

  const closeDrawer = () => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-close]')) closeDrawer();
    const opener = event.target.closest('[data-cart-drawer-open]');
    if (opener && drawer) {
      event.preventDefault();
      openDrawer();
    }
  });

  /* ---------- Cart state sync ---------- */
  const cartSectionIds = () => {
    const ids = [];
    if (drawer) ids.push('cart-drawer');
    const cartPage = document.querySelector('[data-cart-section-id]');
    if (cartPage) ids.push(cartPage.dataset.cartSectionId);
    return ids;
  };

  const applySections = (sections) => {
    if (!sections) return;
    const parser = new DOMParser();
    if (sections['cart-drawer'] && drawer) {
      const fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('[data-cart-drawer-inner]');
      const current = drawer.querySelector('[data-cart-drawer-inner]');
      if (fresh && current) current.replaceWith(fresh);
    }
    const cartPage = document.querySelector('[data-cart-section-id]');
    if (cartPage && sections[cartPage.dataset.cartSectionId]) {
      const fresh = parser.parseFromString(sections[cartPage.dataset.cartSectionId], 'text/html').querySelector('[data-cart-section-id]');
      if (fresh) cartPage.replaceWith(fresh);
    }
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
    document.querySelectorAll('[data-cart-count-a11y]').forEach((el) => {
      el.textContent = `, ${count} items`;
    });
  };

  let changeInFlight = false;
  const changeCartLine = async (line, quantity) => {
    if (changeInFlight) return;
    changeInFlight = true;
    if (drawer) drawer.classList.add('is-busy');
    try {
      const response = await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line,
          quantity,
          sections: cartSectionIds(),
          sections_url: window.location.pathname,
        }),
      });
      if (!response.ok) throw new Error(`Cart update failed (${response.status})`);
      const cart = await response.json();
      applySections(cart.sections);
      updateCartCount(cart.item_count);
    } catch (error) {
      window.location.reload();
    } finally {
      changeInFlight = false;
      if (drawer) drawer.classList.remove('is-busy');
    }
  };

  /* ---------- Quantity controls (event delegation, survives re-render) ---------- */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-change]');
    if (!button) return;
    const control = button.closest('[data-quantity-control]');
    const input = control && control.querySelector('[data-quantity-input], input[type="number"]');
    if (!input) return;
    const min = input.min === '' ? 0 : Number(input.min);
    const current = Number.parseInt(input.value, 10) || 0;
    const next = Math.max(min, current + (button.dataset.quantityChange === 'increase' ? 1 : -1));
    if (next === current) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-line-input]');
    if (!input) return;
    const line = Number(input.dataset.line);
    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
    if (line) changeCartLine(line, quantity);
  });

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-cart-remove]');
    if (!removeButton) return;
    event.preventDefault();
    const line = Number(removeButton.dataset.line);
    if (line) changeCartLine(line, 0);
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();

    const submitButton = form.querySelector('[name="add"]');
    const errorWrapper = form.querySelector('[data-form-error]');
    if (errorWrapper) errorWrapper.hidden = true;
    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('is-loading');
    }

    const formData = new FormData(form);
    formData.append('sections', cartSectionIds().join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(`${routes.cartAdd}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(async (response) => {
        const result = await response.json();
        if (!response.ok) {
          const message = result.description || result.message || 'Something went wrong. Please try again.';
          if (errorWrapper) {
            errorWrapper.textContent = message;
            errorWrapper.hidden = false;
          }
          return;
        }
        applySections(result.sections);
        const countResponse = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } });
        if (countResponse.ok) {
          const cart = await countResponse.json();
          updateCartCount(cart.item_count);
        }
        openDrawer();
      })
      .catch(() => {
        form.submit();
      })
      .finally(() => {
        if (submitButton) {
          submitButton.removeAttribute('aria-busy');
          submitButton.classList.remove('is-loading');
        }
      });
  });

  /* ---------- Product page: variant updates + media gallery ---------- */
  const productForms = document.querySelectorAll('[data-product-wrapper]');
  productForms.forEach((wrapper) => {
    const variantData = wrapper.querySelector('[data-variant-json]');
    const select = wrapper.querySelector('[data-variant-select]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];

    const setActiveMedia = (mediaId) => {
      const slides = wrapper.querySelectorAll('[data-media-slide]');
      const thumbs = wrapper.querySelectorAll('[data-media-thumb]');
      if (!slides.length) return;
      let matched = false;
      slides.forEach((slide) => {
        const isMatch = slide.dataset.mediaSlide === String(mediaId);
        slide.classList.toggle('is-active', isMatch);
        if (isMatch) matched = true;
      });
      if (!matched) slides[0].classList.add('is-active');
      thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', thumb.dataset.mediaThumb === String(mediaId) ? 'true' : 'false');
      });
    };

    wrapper.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-media-thumb]');
      if (thumb) setActiveMedia(thumb.dataset.mediaThumb);
    });

    if (select && variants.length) {
      select.addEventListener('change', () => {
        const variant = variants.find((v) => String(v.id) === select.value);
        if (!variant) return;

        const priceEl = wrapper.querySelector('[data-price]');
        const compareEl = wrapper.querySelector('[data-compare-price]');
        const saveEl = wrapper.querySelector('[data-price-save]');
        const addButton = wrapper.querySelector('[name="add"]');

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = `${saveEl.dataset.savePrefix || 'Save'} ${formatMoney(variant.compare_at_price - variant.price)}`;
        }
        if (addButton) {
          addButton.disabled = !variant.available;
          const label = addButton.querySelector('span') || addButton;
          label.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
        }
        if (variant.featured_media_id) setActiveMedia(variant.featured_media_id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  });
})();
